import type { ReactNode } from 'react'
import { Moon, Sun } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useTheme } from '@/hooks/useTheme'

type ThemeState = ReturnType<typeof useTheme>
type ThemeToggleProps = {
  trigger?: (state: {
    nextTheme: 'light' | 'dark'
    theme: ThemeState['theme']
    toggleTheme: ReturnType<ThemeState['setTheme']>
  }) => ReactNode
}

export function ThemeToggle({ trigger }: ThemeToggleProps = {}) {
  const { setTheme, theme } = useTheme()
  const nextTheme = theme === 'light' ? 'dark' : 'light'
  const toggleTheme = setTheme(nextTheme)

  if (trigger) {
    return trigger({ nextTheme, theme, toggleTheme })
  }

  return (
    <Button variant="outline" size="icon" onClick={setTheme(nextTheme) ?? undefined}>
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}
